<app-preloader *ngIf="isLoading"></app-preloader>
<div class="extract insurance collapsed" [id]="indexDeal + 'insurance' + index">
  <!--!isInsuranceEdition  -->
  <div class="title" *ngIf="!modeEditionProposal">
    <div class="name">
      <label
        class="checkboxWrapper"
        [for]="'insurance' + index + 'deal' + indexDeal"
      >
        <ng-container>
          <input
            type="checkbox"
            [id]="'insurance' + index + 'deal' + indexDeal"
            [(ngModel)]="form.isSelected"
            [disabled]="!form.payments || !form.payments.length || userId != authService.currentUserIds || !isEnabled || readOnlyActions"
            (click)="sendSelectedInsuranceEvent($event, index)"
          />
          <span class="checkmark"></span>
        </ng-container>
        <span class="description">{{ form.dealName }}</span>
      </label>
      <div class="actions" *ngIf="userId == authService.currentUserIds && isValid && !readOnlyActions">
        <a
          (click)="update.emit(index)"
          class="edit"
          tp="Editar seguro"
        ></a>
        <a
          (click)="delete.emit(index)"
          class="delete"
          tp="Eliminar seguro"
          >Eliminar</a
        >
      </div>
    </div>
    <div class="wrapper-duplicate" *ngIf="!form.result">
      <span class="description">Es necesario recalcular</span>
    </div>
    <div class="diroAndRorac">
      <div class="diro">
      </div>
      <div class="rorac" *ngIf="form.roRac">
        <span>RoRAC</span>
        <span>{{ form.roRac }}%</span>
      </div>
    </div>
  </div>
  <div class="resume" *ngIf="!modeEditionProposal">
    <div>
      <span>Producto Financiero</span>
      <span>{{
        financialCalculator.getFinancialProduct(form.financialProductType)
      }}</span>
    </div>
    <div>
      <span>Moneda</span>
      <span>{{ form.currencyType }}</span>
    </div>
    <div>
      <span>Plazo</span>
      <span>{{ form.term }}</span>
    </div>
    <div>
      <span>Tipo de producto</span>
      <span>{{ financialCalculator.getProductType(form.productType) }}</span>
    </div>
    <div>
      <span>Condición</span>
      <span>{{
        financialCalculator.getClassificationType(form.classification)
      }}</span>
    </div>
    <div>
      <span>N° unidades</span>
      <span>{{ form.quantity }}</span>
    </div>
    <div>
      <span>{{ getDisaplayPrice(deal) }}</span>
      <span>{{ getPrice(deal) | currency : "" : ""  }} </span>
    </div>
    <div>
      <span>Enganche</span>
      @if (deal.financialProductType == 'PURE_LEASING'){
      <span>No Aplica</span>
      } @else {
      <span>{{ deal.downPayment | currency : '' : '' }}</span>
      }
    </div>
    <div>
      <span>Total</span>
      <span>{{ getTotalPrice(deal) | currency : "" : "" }}</span>
    </div>
    <a
      class="accordionControl"
      (click)="viewInsurance(index)"
      tp="{{collapsed ? 'Ver detalle' : 'Ocultar detalle'}}"
      ></a
    >
  </div>
  <div class="accordionWrapper">
    <div>
      <app-deal-view [deal]="form" [grace]="grace" [isManualInsurance]="true" [nameCompany]="nameCompany"></app-deal-view>
    </div>
  </div>
</div>
